import moment, { Moment } from 'moment'

import { TFunction } from 'react-i18next'
import {
  InfluencerCampaignStatus,
  InfluencerEventStatus,
} from 'Redux/reducers/influencerReducer'
import { colors } from 'Styled/variables'

export const getStatusView = (
  status: InfluencerCampaignStatus | InfluencerEventStatus | string,
  t: TFunction<'translation'>
) => {
  switch (status) {
    case InfluencerCampaignStatus.RUNNING:
    case InfluencerCampaignStatus.IN_PROCESS:
    case InfluencerEventStatus.ACCEPTED:
      return { text: t('influencer.running'), color: colors.messegesYellow1 }

    case InfluencerEventStatus.AWAITING_MODERATOR_REVIEW:
    case InfluencerCampaignStatus.AWAITING_REVIEW:
      return { text: t('influencer.awaitingReview'), color: colors.mainText }

    case InfluencerEventStatus.APPROVED_BY_ARTIST:
    case InfluencerEventStatus.APPROVED_AUTOMATICALLY:
    case InfluencerEventStatus.APPROVED_BY_ADMIN:
      return { text: t('influencer.completed'), color: colors.messegesGreen1 }

    case InfluencerCampaignStatus.CANCELED:
    case InfluencerEventStatus.CANCELED_BY_ARTIST:
      return { text: t('influencer.canceled'), color: colors.messegesRed }

    default:
      return { text: t('influencer.new'), color: colors.messegesGreen1 }
  }
}

export const calcTimeLeft = (endDate: string | Moment, t: TFunction) => {
  const daysLeft = moment(endDate).diff(moment(), 'days')

  if (daysLeft && daysLeft > 0) {
    return `${daysLeft} ${t('influencer.daysLeft')}`
  }

  const hoursLeft = moment(endDate).diff(moment(), 'hours')

  if (hoursLeft && hoursLeft > 0) {
    return `${hoursLeft} ${t('influencer.hoursLeft')}`
  }

  return ''
}

export enum TabKeys {
  new = 'new',
  in_progress = 'in_progress',
  awaiting = 'awaiting',
  completed = 'completed',
  canceled = 'canceled',
}

export const getTabs = (tubCounts: {
  newTracks: number
  inProgress: number
  awaitingReview: number
  completed: number
  canceled: number
}) => [
  {
    key: TabKeys.new,
    title: 'influencer.newTracksTab',
    numbers: tubCounts?.newTracks,
  },
  {
    key: TabKeys.in_progress,
    title: 'influencer.inProgressTab',
    numbers: tubCounts?.inProgress,
  },
  {
    key: TabKeys.awaiting,
    title: 'influencer.awaitingReviewTab',
    numbers: tubCounts?.awaitingReview,
  },
  {
    key: TabKeys.completed,
    title: 'influencer.CompletedTab',
    numbers: tubCounts?.completed,
  },
  {
    key: TabKeys.canceled,
    title: 'influencer.CanceledTab',
    numbers: tubCounts?.canceled,
  },
]

export enum StatusTextEnum {
  NEW_TRACK = 'New track',
  IN_PROGRESS = 'In progress',
  AWAITING_REVIEW = 'Awaiting review',
  COMPLETE = 'Complete',
  CANCELED = 'Canceled',
}
